import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { Product, BadgeDto } from '../../dto';
import { BADGE_TYPE } from '../../shared/common-code.type';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { BestSellerProductSetting } from 'src/app/dto/best-seller';
dayjs.extend(isBetween);

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'badges',
})
export class BadgesPipe implements PipeTransform {
  BADGE_CATEGORY = {
    [BADGE_TYPE.NEW]: '009001',
    [BADGE_TYPE.BEST]: '009002',
    // [BADGE_TYPE.PROMOTION]: '',
    // [BADGE_TYPE.SALE]: '',
    [BADGE_TYPE.UMMA_PICK]: '009003',
  };

  BADGE_CONFIG = {
    badge: {
      [BADGE_TYPE.NEW]: true,
      [BADGE_TYPE.BEST]: true,
      [BADGE_TYPE.PROMOTION]: true,
      [BADGE_TYPE.SALE]: true,
      [BADGE_TYPE.ROCKET]: true,
      [BADGE_TYPE.CRUELTY]: true,
      [BADGE_TYPE.VEGAN]: true,
      [BADGE_TYPE.CLEARANCE]: true,
      [BADGE_TYPE.CPNP]: true,
      ALL: true,
    },
    flag: {
      [BADGE_TYPE.PERCENT]: true,
      [BADGE_TYPE.UMMA_PICK]: true,
      [BADGE_TYPE.ROCKET]: true,
      [BADGE_TYPE.CRUELTY]: true,
      [BADGE_TYPE.VEGAN]: true,
      [BADGE_TYPE.CLEARANCE]: true,
      [BADGE_TYPE.CPNP]: true,
    },
    best: {
      [BADGE_TYPE.NEW]: true,
    },
  };

  transform(
    product: Product | BestSellerProductSetting,
    type: 'flag' | 'badge' | 'best',
    excludeBadges: string[] = []
  ): BadgeDto[] {
    const badges = [];

    if (!product) {
      return badges;
    }

    if (product.badges) {
      product.badges
        .filter((badge) => {
          if (!badge.started && !badge.ended) {
            return true;
          } else if (!badge.started && badge.ended) {
            return dayjs().isBefore(dayjs(badge.ended));
          } else if (badge.started && !badge.ended) {
            return dayjs().isAfter(dayjs(badge.started));
          } else {
            return dayjs().isBetween(dayjs(badge.started), dayjs(badge.ended));
          }
        })
        .map((badge) => {
          // 비어있는 배열은 기본값 적용
          if (excludeBadges.length === 0) {
            excludeBadges = ['BEST', 'CLEARANCE', 'NEW', 'PERCENT', 'PROMOTION', 'SALE', 'UMMA_PICK'];
          }
          this.__addBadge(type, badges, badge, excludeBadges);
        });
    }

    if ((product as Product).mapperDisplayCategoryProducts) {
      (product as Product).mapperDisplayCategoryProducts.map((mapperDisplayCategoryProduct) => {
        if (mapperDisplayCategoryProduct.displayCategory.parentCode === this.BADGE_CATEGORY.NEW) {
          if (dayjs(mapperDisplayCategoryProduct.displayCategory.created).isAfter(dayjs().add(-14, 'day'))) {
            this.__addBadge(type, badges, new BadgeDto({ badgeType: BADGE_TYPE.NEW }), excludeBadges);
          }
        }
        if (mapperDisplayCategoryProduct.displayCategory.code === this.BADGE_CATEGORY.BEST) {
          this.__addBadge(type, badges, new BadgeDto({ badgeType: BADGE_TYPE.BEST }), excludeBadges);
        }
        if (mapperDisplayCategoryProduct.displayCategory.code === this.BADGE_CATEGORY.UMMA_PICK) {
          this.__addBadge(type, badges, new BadgeDto({ badgeType: BADGE_TYPE.UMMA_PICK }), excludeBadges);
        }
      });
    }

    return badges;
  }

  __addBadge(type: 'flag' | 'badge' | 'best', badges: BadgeDto[], badge: BadgeDto, excludeBadges?: string[]) {
    if (excludeBadges.includes(badge.badgeType) || excludeBadges.includes('ALL')) {
      // console.log(1, this.BADGE_CONFIG[type], this.BADGE_CONFIG[type], type, badge, excludeBadges);
      return;
    }

    if (this.BADGE_CONFIG[type] && this.BADGE_CONFIG[type][badge.badgeType]) {
      // console.log(2, this.BADGE_CONFIG[type], this.BADGE_CONFIG[type], type, badge);
      badges.push(badge);
    }
  }
}
